module.exports = __webpack_public_path__ + "img/1.c1bdd39e.png";